import { StatusCategoryCodes, StatusCategoryKinds } from '../../../constants/workflows';

type StatusLike =
  | {
      category?: string | null;
      category_kind?: string | null;
    }
  | null
  | undefined;

/**
 * Mirrors backend `Opportunity.is_live()`: still taking provider responses = an
 * initial- or transitory-kind status that is not the LOCKED (max providers) category.
 * Category-driven on purpose — never a list of status codes.
 */
export function isOpportunityLive(status: StatusLike): boolean {
  const kind = status?.category_kind;
  return (
    (kind === StatusCategoryKinds.INITIAL || kind === StatusCategoryKinds.TRANSITORY) &&
    status?.category !== StatusCategoryCodes.LOCKED
  );
}

type RebroadcastSubject =
  | {
      current_status?: StatusLike;
      rebroadcast_eligible_count?: number | null;
    }
  | null
  | undefined;

export type RebroadcastAvailability = {
  /** Show the button at all (permission + live opportunity). */
  visible: boolean;
  /** CANCELED + PROV_UNRESPONSIVE connections the backend would reopen. */
  count: number;
  /** Visible and something to send to. */
  enabled: boolean;
};

export function getRebroadcastAvailability(
  opportunity: RebroadcastSubject,
  canEdit: boolean
): RebroadcastAvailability {
  const visible = canEdit && isOpportunityLive(opportunity?.current_status);
  const count = opportunity?.rebroadcast_eligible_count ?? 0;
  return { visible, count, enabled: visible && count > 0 };
}
